import NavigableModal from '@components/NavigableModal/NavigableModal';
import { Icon } from '@tkww/orion-web-ds-graphic';
import { GridColumn, GridRow } from '@tkww/orion-web-ds-structure';
import LocationTypeahead from '@xo-union/tk-component-location-typeahead';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Styles from './styles.scss';

export default class Location extends PureComponent {
	static propTypes = {
		location: PropTypes.object.isRequired,
		initialLocation: PropTypes.object.isRequired,
		setLocation: PropTypes.func.isRequired,
	};

	state = {
		modalIsOpen: false,
	};

	componentDidMount = () => {
		this.props.setLocation(this.props.initialLocation);
	};

	setLocation = (location) => {
		this.closeModal();
		this.props.setLocation(location);
	};

	getFormattedLocation = () =>
		[this.props.location.city, this.props.location.stateCode].join(', ');

	openModal = () => {
		this.setState({ modalIsOpen: true });
	};

	closeModal = () => {
		this.setState({ modalIsOpen: false });
	};

	render() {
		return (
			<GridRow>
				<GridColumn md="6" lg="12" className={Styles.locationText}>
					See top wedding vendors rated by couples near&nbsp;
					<button
						type="button"
						onClick={this.openModal}
						className={Styles.locationLink}
					>
						{this.getFormattedLocation()}
						<Icon name="pencil" size="md" aria-label="Edit location" />
					</button>
					{this.state.modalIsOpen && (
						<NavigableModal
							isModalOpen={this.state.modalIsOpen}
							closeCallback={this.closeModal}
							size="md"
							className={Styles.locationModal}
						>
							<div className={Styles.typeAheadText}>
								What&apos;s your wedding location?
							</div>
							<LocationTypeahead onChange={this.setLocation} />
							<div className={Styles.modalBottom} />
						</NavigableModal>
					)}
				</GridColumn>
			</GridRow>
		);
	}
}
